import React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string;
};

const SpotifyIcon = ({ title, ...props }: Props) => {
    return (
        <svg
            {...props}
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-label={title}
        >
            {title && <title>{title}</title>}
            <path
                d="M16.1772 0C7.37725 0 0.177246 7.2 0.177246 16C0.177246 24.8 7.37725 32 16.1772 32C24.9772 32 32.1772 24.8 32.1772 16C32.1772 7.2 25.0572 0 16.1772 0ZM22.1772 23.44C18.4172 21.12 13.6972 20.64 8.09725 21.92C7.53725 22.08 7.05725 21.68 6.89725 21.2C6.73725 20.64 7.13725 20.16 7.61725 20C13.6972 18.64 18.9772 19.2 23.1372 21.76C23.6972 22 23.7772 22.64 23.5372 23.12C23.2172 23.6 22.6572 23.76 22.1772 23.44ZM23.7772 19.12C19.4572 16.48 12.8972 15.68 7.85725 17.28C7.21725 17.44 6.49725 17.12 6.33725 16.48C6.17725 15.84 6.49725 15.12 7.13725 14.96C12.9772 13.2 20.1772 14.08 25.1372 17.12C25.6172 17.36 25.8572 18.16 25.4572 18.72C25.0572 19.28 24.3372 19.52 23.7772 19.12ZM7.05725 12.4C6.25725 12.64 5.45725 12.16 5.21725 11.44C4.97725 10.64 5.45725 9.84 6.17725 9.6C11.8572 7.92 21.2172 8.24 27.1372 11.76C27.8572 12.16 28.0972 13.12 27.6972 13.84C27.2972 14.4 26.3372 14.64 25.6172 14.24C20.4972 11.2 11.9372 10.88 7.05725 12.4Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default SpotifyIcon;
